import axios from "axios";

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
});

class Api {
  static async get(url: string, params = {}, data = {}) {
    const response = await client.get(url, {
      params,
      headers: await this.getHeaders(),
    });
    return response;
  }

  static async post(url: string, params = {}) {
    const config = {
      headers: await this.getHeaders(),
    };

    const response = await client.post(url, params, config);
    return response;
  }

  // to be updated
  static async update(url: string, params = {}) {
    const config = {
      headers: await this.getHeaders(),
      // validateStatus,
    };

    const response = await client.put(url, params, config);
    return response;
  }

  // to be delete
  static async delete() {
    // do nothing.
   }

  static async getHeaders() {
    return {
      "Content-Type": "application/json; charset=utf-8",
    };
  }

}

export default Api;
